export default "__VITE_ASSET__Clj8pYNQ__"